import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useState} from "react";
import styled from "@emotion/styled/macro";
import {IImages, ISlsOrd} from "../../../kova/slsordClient";
import {useUserContext} from "../../../context/userContext";
import {useReservationClient} from "../../../data/slsOrdSource";

import {ThemeColors} from "../../layout/GlobalLayout";
import {useDataInvalidation} from "../../../App";
import {CameraCard} from "../vscFindYourHome/CameraCards";
import {getItemsForTab, useModelConfig} from "./UseModelConfig";
import {ViewTabs} from "../../ViewTabs";
import Switch from "./Switch";
import {PlanLayout} from "../plan/Plan";
import {VscBigScreenWebPage} from "../../content/ButtonComponent";
import {useVscContext} from "../../content/VscReactContext";
import AdminPortal from "../../admin/AdminPortal";
import SiteSpecificAdmin from "../siteSpecific/SiteSpecificAdmin";
import {filterViewItems, IModelConfig, IOptionConfig} from "../../../data/IViewpoint";
import {SiteSpecific3DMap} from "./SiteSpecific3DMap";
import {SiteSpecific2DMap} from "./SiteSpecific2DMap";
import {UnrealOptions} from "../plan/ConfiguratorSelections";
import {getChoices, getViewOptions} from "../../../data/getViewOptions";
import {VscVideoPlayer} from "../../video/VscVideoPlayer";

export const SiteSpecificDiv = styled.div`
display:flex;
  overflow:hidden;
  flex-direction:row;
  height:100%;
  > * {
    flex: 1 1 1px;
    align-items: stretch;
  }
  .views {
    padding:16px;
    overflow-y:scroll;
    
    .furnitureswitch {
      margin-top: 20px;
    }
    h2 { text-transform: uppercase;}
    flex-grow: 1;
    display:flex;
    flex-direction: column;
    flex-basis: 209px;
    background-color: white;
    .button {
      text-transform: none;

    }
    .cameras {
      margin-top:32px;
      button {
        height: 200px;
        width: 200px;
      }
      display:flex;
      flex-wrap: wrap;gap: 32px;
    }
  }
  .selections {
    background-color: var(--content-background);
  }
  .views .viewbuttons {
    
    flex-grow:1;
  }
  
  .selections {
    max-width: 300px;
    display:flex;
    
    justify-content:center;
    > * {
      
    }
  }

  .back {
  
    text-decoration: none;
    font-weight: bold;
    color: var(--secondary-color);
    align-self: center;
    margin-bottom:20px;
  }
   .controls {
     text-transform: none;

     margin-top:24px;
     margin-left:auto;
     margin-right:auto;
    justify-self: center;
     align-self: center;
    height:45px;
    display:flex;
     font-size:10px;
    background-color: ${ThemeColors.platinum};
    border-radius:8px;
    width:145px;
    > * {
      display: flex;
      align-items: center;
      justify-content:center;
      width: 50%;
    }
    .selected {
      box-shadow: 0px 0px 1px rgba(20, 20, 20, 0.04), 0px 0px 8px rgba(20, 20, 20, 0.08);
      border-radius: 6px;
      background-color: white;
    }
    top: 32px;
    
  }
  .furnitureswitch {
    
  }
  
`

const OptionLine: React.FC<{optionName?: string}> = (props) => {


    const { optionName } = props;
    if (optionName === undefined) return null;
    return <p className={"item"}><img src={"/images/check.svg"} /> <span>{optionName}</span></p>
}
const SiteSpecificSelectionsDiv = styled.div`
display:flex; 
  min-height:100%;
  max-width:243px;
  justify-content: space-between;
  flex-direction: column;
  .mainContent {
    overflow-y: scroll;
    margin-top: 32px;
  }
  .reserve {
    
    padding-bottom:32px; align-self: center;
    button {
      color: white;
      background-color: var(--primary-color);
      border-radius: 50px;
      padding: 14px 32px;
      border:0;
      
    }
  }
  h4 {
    font-weight: 400; font-style: normal; font-size: 18px; line-height: 25px;
  
  }
  .title {
    display:flex;
    position:relative;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    line-height:22px;
    font-weight:400;
    text-transform: uppercase;
    
    svg {
      left:0;
      height:100%;
      position:absolute;
    }
  }
  .item {
    margin-top:10px;
    margin-bottom:0;

    word-break: break-word;
    img {
      margin:10px;
    }
    
    min-height: 38px;
    display:flex;
    justify-content:flex-start;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    align-items: center;
    background-color: white;
    
  }
`


export const SiteSpecificSelections: React.FC<{
    slsOrd: ISlsOrd,
    modelConfig: IModelConfig}> = (props) => {
    const { slsOrd, modelConfig } = props;
    const options = normalizeOptions(modelConfig.marketHomeOptions ?? modelConfig.options);




    const userContext = useUserContext();
    useReservationClient();
    useDataInvalidation();

    const navigate = useNavigate();

    function getOptName(selectionId:string) {
        const opt = slsOrd.options.find(soo => soo.selectionID === selectionId);
        if (opt === undefined) {
            console.error(selectionId);

            return undefined;
        }
        /*
        if (opt?.selectionID === "WH_DESIGNPKG") {
            return "Interior Design Package: " + opt.style;
        }
        if (opt?.selectionID === "GARAGE") {
            if (opt.valueName === "Not Selected") {
                return "No Garage";
            }
            return opt.valueName;
        }*/
        return opt?.selectionName + ": " + opt?.valueName ?? "";

    }
    // -1 if not on waitlist.
    slsOrd.waitlist.findIndex(elem => elem === userContext.user?.id);

    const mostImportantOption = options && options[0];

    return <SiteSpecificSelectionsDiv>



        <div className={"mainContent"}>
            <a href='#' onClick={(ev: React.MouseEvent) => {ev.preventDefault(); navigate(-1); } } className={"back"}>
                &lt; Back</a>


            <h4>Model</h4>
            <OptionLine optionName={slsOrd.marketingName} />
            <OptionLine optionName={getOptName(mostImportantOption?.name)} />

            { options?.find(x => x.id === "EXT_COLORS") && getOptName("EXT_COLORS") && <>
            <h4>Color Package</h4>
            { getOptName("EXT_COLORS")!.split(" / ").map(colorElement => <OptionLine optionName={colorElement} />) }
            </> }

            <h4>Options</h4>
            { options.map(opt => {
                if (slsOrd.options.find(soo => soo.selectionID === opt.id) !== undefined) {
                    return <OptionLine key={opt.id} optionName={getOptName(opt.name)!} />
                }
            })
            }
        </div>

    </SiteSpecificSelectionsDiv>

}

export const DialogDiv = styled.div`
position:fixed;
  display:flex;
  justify-content:center;
  align-content:center;
  top:0;bottom:0;right:0;left:0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
  > * {
    align-self: center;justify-self:center;
  }
  
`


export function normalizeOptions(optionsVisible?: IOptionConfig[]) {
    return optionsVisible?.map(ov => typeof ov === "string" ? {id: ov, name: ov} : ov) ?? [];
}

export interface ISiteSpecificProps {
    slsOrds: ISlsOrd[],
    favorites: Set<number>,
    updateFavorites: (favorites:Set<number>) => void
}
const SiteSpecific: React.FC<ISiteSpecificProps> = (props) => {


    const {slsOrds} = props;
    const vscContext = useVscContext();
    let [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const [viewItemIndex, setViewItemIndex] = useState<number>(0);
    const [activeViewTab, setActiveViewTab] = useState<string | null>(null);
    const [showFurniture, setShowFurniture] = useState<boolean>(true);
    if (slsOrds === null) throw new Error("no slsords");
    const slsOrd = slsOrds.find(h => h.id === id) ?? slsOrds[0];

    const modelConfig = useModelConfig(slsOrd.modelId ?? "");

    if (modelConfig === null) return null;

    // We enable furniture if we have even one view item with a camera.
    const enableFurniture = modelConfig.views.flatMap(v => v.items).find(itm => itm.type === "camera") !== undefined;
    const viewTabs = modelConfig.views.map(v => v.name) ?? [];
    const activeTabToUse = activeViewTab ?? viewTabs[0] ?? "";

    const allViewItems = getItemsForTab(activeTabToUse, modelConfig);
    const viewItems = filterViewItems(allViewItems, ["markethome"]);
    let selectedViewItem = viewItems[viewItemIndex];
    if (!selectedViewItem) {
        selectedViewItem = viewItems[0];
    }

    const viewOptions = getViewOptions(selectedViewItem, showFurniture);

    const activeChoices = getChoices(viewOptions);
    return <PlanLayout>
        <AdminPortal>
            <SiteSpecificAdmin activeCamera={selectedViewItem.name} slsOrd={slsOrd} modelConfig={modelConfig}/>
        </AdminPortal>
        <UnrealOptions choices={activeChoices} lotId={slsOrd.unrealId}/>

        <div className={"content"}>
            <SiteSpecificDiv>
                { (selectedViewItem.type === "camera" || selectedViewItem.type === "viewpoint") && <SiteSpecific3DMap lotId={slsOrd.unrealId} selectedViewItem={selectedViewItem} modelConfig={modelConfig} /> }
                { selectedViewItem.type === "map" && <SiteSpecific2DMap lotId={slsOrd.unrealId} selectedViewItem={selectedViewItem}/> }
                { selectedViewItem.type === "image" && <VscBigScreenWebPage url={`StaticContent.html?shared=global&image=${encodeURIComponent(
                    selectedViewItem.imageId ?  
                        vscContext.getVisualizerControllerUri(slsOrd.images[selectedViewItem.imageId as keyof IImages]!) 
                        : vscContext.getVisualizerContentUri(selectedViewItem.image!))}`} /> }
                { selectedViewItem.type === "video" && <VscVideoPlayer videoName={selectedViewItem.video} videoTitle={selectedViewItem.name} looping={selectedViewItem.looping ?? false} /> }

                <div className={"views"}>
                    <ViewTabs viewTabs={viewTabs} activeViewTab={activeTabToUse}
                              onSetActiveViewTab={(tabName: string) => {
                                  setViewItemIndex(0);
                                  setActiveViewTab(tabName);
                              }}/>
                    <div className={"cameras"}>
                        {viewItems.map((cam, idx) => <CameraCard key={idx} camera={cam} isActive={idx === viewItemIndex} onClick={() => setViewItemIndex(idx)}/>)}
                    </div>

                </div>

                <div className={"selections"}>
                    <SiteSpecificSelections slsOrd={slsOrd}
                                            modelConfig={modelConfig}

                    />
                </div>

            </SiteSpecificDiv>
        </div>
        <div className={"footer"}>
            { (enableFurniture) && <Switch checked={showFurniture} onChange={() => setShowFurniture(old => !old)}>Furniture</Switch> }
        </div>
    </PlanLayout>
}

export default SiteSpecific;